<script setup lang="ts">
import { computed } from 'vue';
import { URL_SEARCH } from '@tools/routes/routes';
import { IconMagnifyingGlass } from '@icons';
import { trans } from '@tools/translation';
import { getLastSearchData } from '@tools/last-search';
import Icon from '@components/Icon.vue';
import Typography from '@components/Typography.vue';

const lastSearch = getLastSearchData();
const searchLabel = computed(() => lastSearch?.labelText ?? trans('user_menu.top.search'));
const searchHref = computed(() => lastSearch?.url || URL_SEARCH);
</script>

<template>
  <a
    :href="searchHref"
    :class="[
      'rounded-full border border-solid border-gray',
      'bg-gray-lighter hover:bg-gray focus:bg-gray',
      'h-[40px] w-[358px] lg:w-[256px] xl:w-[358px]',
      'flex items-center gap-3',
      'py-2 pl-3 pr-1',
      'no-underline',
    ]"
  >
    <Typography
      variant="body"
      color="gray-darker"
      class="min-w-0 flex-1 truncate"
    >
      {{ searchLabel }}
    </Typography>

    <div class="flex rounded-[20px] bg-blue p-[6px]">
      <Icon
        :svg="IconMagnifyingGlass"
        width="20"
        height="20"
        fill="white"
      />
    </div>
  </a>
</template>
